import { FacebookFollowLink } from './FacebookFollowLink';

/**
 * @param {{ location: string; className?: string; title?: string; lede?: string }} props
 */
export function FacebookGeneralDealsNudge({
  location,
  className = '',
  title = 'Follow on Facebook',
  lede = 'See Malta deals first — price drops, new local shops, and bargains we spot before they\u2019re gone.',
}) {
  return (
    <div
      className={`search-alert-panel__facebook${className ? ` ${className}` : ''}`}
    >
      <p className="search-alert-panel__email-label">{title}</p>
      <p className="search-alert-panel__facebook-lede">{lede}</p>
      <FacebookFollowLink location={location} />
    </div>
  );
}
